import CampaignInfo from './campaign_info'
import { connect } from 'react-redux'
import {
  daysUntilToday,
  daysFromToday,
  daysFromTo,
} from 'shared/helpers/datetime_helpers'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  let daysPassed, daysRemaining
  if (campaign.end_date && new Date(campaign.end_date) < new Date()) {
    daysPassed =
      daysFromTo(new Date(campaign.start_date), new Date(campaign.end_date)) + 1
  } else {
    daysPassed = daysUntilToday(new Date(campaign.start_date)) + 1
  }

  if (campaign.end_date) {
    daysRemaining = daysFromToday(new Date(campaign.end_date))
  }
  // checking for daysRemaining just in case that the user's clock is off
  let notExpired = daysRemaining == null || daysRemaining >= 0

  return {
    title: campaign.title,
    currentValue: campaign.current_value + campaign.pledge,
    goal: campaign.goal,
    currency: campaign.currency,
    contributionsCount: campaign.preview ? 0 : campaign.txn_count,
    canChipIn: campaign.can_chip_in && notExpired,
    endDate: new Date(campaign.end_date),
    preview: campaign.preview,
    shareProgress: campaign.share_progress,
    pledge: campaign.pledge,
    name: campaign.owner && campaign.owner.first_name,
    daysPassed,
    daysRemaining,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignInfo)
